module.exports = __webpack_public_path__ + "img/photo-0104.3e1b3cb2.jpg";